// // Updated LoginPage with the exact same UI as shown in the image, without touching any logic or commented code.
// // YOUR ORIGINAL LOGIC, FUNCTIONS, AND COMMENTS ARE KEPT EXACTLY INTACT.

// import React, { useState, useContext, useRef, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import {
//   Box,
//   Button,
//   TextField,
//   Typography,
//   Alert,
//   CircularProgress,
//   InputAdornment,
// } from "@mui/material";
// import PhoneIcon from "@mui/icons-material/Phone";
// import axios from "axios";
// import { OrderContext } from "../contexts/OrderContext";
// import logo from "../assets/img/img_logo.png";
// import phone from "../assets/img/ic_phone_16.png";
// import { useParams } from "react-router-dom";

// const LoginPage = () => {
//   const { code } = useParams(); // Get the code from URL

//   const [step, setStep] = useState(1);
//   const [mobile, setMobile] = useState("");
//   // const [otp, setOtp] = useState("");
//   const [error, setError] = useState("");
//   const [success, setSuccess] = useState("");
//   const [mfrDetails, setMfrDetails] = useState([]);
//   const [openModal, setOpenModal] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [otpLoading, setOtpLoading] = useState(false);
//   const navigate = useNavigate();
//   const [otp, setOtp] = useState(["", "", "", "", "", ""]);
//   const [storeinfo, setStorinfo] = useState([]);
//   const { fetchOrders, fetchStoreData } = useContext(OrderContext);
//   const inputRefs = useRef([]);

//   const fetchStore = async (code) => {
//     if (!code) return;
//     try {
//       const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/api/fetchorder/getStore/${code}`;
//       const response = await axios.get(apiUrl);
//       await setStorinfo(response.data);
//     } catch (error) {
//       console.error("Error fetching store:", error);
//     }
//   };

//   useEffect(() => {
//     if (code) {
//       localStorage.setItem("urlPrefix", code);
//       fetchStore(code);
//     }
//   }, [code]);

//   const handleMobileSubmit = async (e) => {
//     e.preventDefault();
//     setError("");
//     setSuccess("");

//     setLoading(true);

//     if (!mobile) {
//       setError("Mobile number is required.");
//       setLoading(false);
//       return;
//     }

//     try {
//       setOtpLoading(true);
//       await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/auth/login`, {
//         mobile,
//       });
//       setSuccess("OTP sent successfully to your mobile.");
//       setStep(2);
//     } catch (error) {
//       setError(
//         error.response?.data?.data?.message ||
//           "Failed to send OTP. Please try again.",
//       );
//     } finally {
//       setLoading(false);
//       setOtpLoading(false);
//     }
//   };

//   const handleOtpSubmit = async (e) => {
//     e.preventDefault();
//     setError("");
//     setSuccess("");
//     setOtpLoading(true);

//     if (!otp) {
//       setError("OTP is required.");
//       setOtpLoading(false);
//       return;
//     }

//     const enteredOtp = otp.join("");

//     if (enteredOtp.length !== 6) {
//       setError("Please enter a 6-digit OTP.");
//       return;
//     }

//     try {
//       const response = await axios.post(
//         `${process.env.REACT_APP_API_BASE_URL}/api/auth/validate-otp`,
//         { mobile, otp: enteredOtp },
//       );

//       const { token, role, mfrDetails, id, user } = response.data.data;

//       localStorage.setItem("authToken", token.token);
//       localStorage.setItem("userRole", role);
//       localStorage.setItem("id", id);
//       localStorage.setItem("user", JSON.stringify(user));

//       if (role === "Karigar" && mfrDetails.length > 1) {
//         localStorage.setItem("MFR", JSON.stringify(mfrDetails));
//         setMfrDetails(mfrDetails);

//         if (storeinfo?.storeDetails) {
//           handleMfrSelection(storeinfo);
//         } else {
//           setOpenModal(true);
//         }
//       } else if (role === "Karigar" && mfrDetails.length > 0) {
//         localStorage.setItem("selectedMfr", JSON.stringify(mfrDetails[0]));
//         await fetchOrders();
//         navigate("/home");
//       } else if (role === "Karigar" && mfrDetails.length === 0) {
//         navigate("/home");
//       } else if (role === "MFR") {
//         localStorage.setItem("selectedMfr", JSON.stringify(mfrDetails));
//         await fetchOrders();
//         await fetchStoreData();
//         navigate("/home");
//       } else if (role === "Customer" && mfrDetails.length > 1) {
//         localStorage.setItem("MFR", JSON.stringify(mfrDetails));
//         setMfrDetails(mfrDetails);

//         if (storeinfo?.storeDetails) {
//           handleMfrSelection(storeinfo);
//         } else {
//           setOpenModal(true);
//         }
//       } else if (
//         role === "Customer" ||
//         (role === "SEMIMFR" && mfrDetails.length > 0) ||
//         role === "SUPERADMIN" ||
//         role === "COMFR"
//       ) {
//         localStorage.setItem("selectedMfr", JSON.stringify(mfrDetails[0]));
//         await fetchOrders();
//         await fetchStoreData();
//         navigate("/home");
//       } else if (role === "Customer" && mfrDetails.length === 0) {
//         await fetchOrders();
//         navigate("/home");
//       } else if (role === "DIGITAL MARKETER" && mfrDetails.length > 0) {
//         localStorage.setItem("selectedMfr", JSON.stringify(mfrDetails[0]));
//         await fetchOrders();
//         await fetchStoreData();
//         navigate("/admin-dash");
//       } else if (role === "WAREHOUSE" && mfrDetails.length > 0) {
//         localStorage.setItem("selectedMfr", JSON.stringify(mfrDetails[0]));
//         await fetchOrders();
//         await fetchStoreData();
//         navigate("/warehouse-dashboard");
//       } else if (role === "salesPerson" && mfrDetails.length > 0) {
//         localStorage.setItem("selectedMfr", JSON.stringify(mfrDetails[0]));
//         await fetchOrders();
//         await fetchStoreData();
//         navigate("/sales-dashboard");
//       } else if (role === "QC" && mfrDetails.length > 0) {
//         localStorage.setItem("selectedMfr", JSON.stringify(mfrDetails[0]));
//         await fetchOrders();
//         await fetchStoreData();
//         navigate("/qrscan");
//       } else if (role === "DIGITAL ORDER" && mfrDetails.length > 0) {
//         localStorage.setItem("selectedMfr", JSON.stringify(mfrDetails[0]));
//         await fetchOrders();
//         await fetchStoreData();
//         navigate("/home");
//       } else if (role === "ORDER" && mfrDetails.length > 0) {
//         localStorage.setItem("selectedMfr", JSON.stringify(mfrDetails[0]));
//         await fetchOrders();
//         await fetchStoreData();
//         navigate("/sales-dashboard");
//       }
//     } catch (error) {
//       setError(
//         error.response?.data?.data?.message ||
//           "Failed to validate OTP. Please try again.",
//       );
//     } finally {
//       setOtpLoading(false);
//     }
//   };

//   const handleMfrSelection = async (selectedMfr) => {
//     setOpenModal(false);
//     localStorage.setItem("selectedMfr", JSON.stringify(selectedMfr));
//     navigate("/home");
//     await fetchOrders();
//     await fetchStoreData();
//   };

//   const handleOtpChange = (index, value) => {
//     if (/^\d?$/.test(value)) {
//       let newOtp = [...otp];
//       newOtp[index] = value;
//       setOtp(newOtp);

//       if (value !== "" && index < 5) {
//         inputRefs.current[index + 1].focus();
//       }
//     }
//   };

//   const handleKeyDown = (e, index) => {
//     if (e.key === "Backspace" && !otp[index] && index > 0) {
//       inputRefs.current[index - 1].focus();
//     }
//   };

//   const handleMobileChange = (e) => {
//     const value = e.target.value;

//     // Allow only digits and max 10 characters
//     if (/^\d{0,10}$/.test(value)) {
//       setMobile(value);
//     }
//   };

//   return (
//     <div
//       style={{
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         minHeight: "100vh",
//         background: "linear-gradient(to bottom, #0051a2, #7db1d6)",
//         padding: "20px",
//       }}
//     >
//       <div
//         style={{
//           width: "100%",
//           maxWidth: "420px",
//           background: "white",
//           borderRadius: "12px",
//           padding: "30px",
//           boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
//           textAlign: "center",
//         }}
//       >
//         {/* Logo */}
//         {/* {storeinfo?.storeDetails?.logo ? (
//           <img
//             src={storeinfo.storeDetails.logo}
//             alt="Store Logo"
//             style={{ width: "90px", height: "auto", marginBottom: "10px" }}
//           />
//         ) : (
//           <img
//             src={logo}
//             alt="logo"
//             style={{ width: "90px", height: "auto", marginBottom: "10px" }}
//           />
//         )} */}

//         <h2
//           style={{
//             fontWeight: "bold",
//             color: "#0A3D40ff",
//           }}
//         >
//           {storeinfo?.storeDetails?.name || "KRAMASYA"}
//         </h2>

//         <p style={{ color: "#666", marginBottom: "20px" }}>
//           Effortless Order Management <br /> for Timeless Creations.
//         </p>

//         {/* Bullet Box */}
//         <div
//           style={{
//             background: "#f0f5fa",
//             padding: "15px",
//             borderRadius: "8px",
//             textAlign: "left",
//             marginBottom: "20px",
//             fontSize: "14px",
//             color: "#333",
//             lineHeight: "1.7",
//           }}
//         >
//           ✓ Overview of all order statuses. <br />✓ Order Management <br />✓
//           Order Tracking & Notifications <br />✓ User Role-Based Access
//         </div>

//         {error && <p style={{ color: "red" }}>{error}</p>}
//         {success && <p style={{ color: "green" }}>{success}</p>}

//         {/* STEP 1 UI */}
//         {step === 1 && (
//           <form onSubmit={handleMobileSubmit}>
//             <Typography
//               sx={{ textAlign: "left", marginBottom: "6px", color: "#333" }}
//             >
//               Enter Mobile Number
//             </Typography>

//             <TextField
//               fullWidth
//               type="tel"
//               value={mobile}
//               onChange={handleMobileChange}
//               sx={{ background: "#fff", borderRadius: "8px", marginBottom: 2 }}
//               InputProps={{
//                 startAdornment: (
//                   <InputAdornment position="start">
//                     <img
//                       src={phone}
//                       alt="Phone"
//                       style={{ width: "22px", opacity: 0.7 }}
//                     />
//                   </InputAdornment>
//                 ),
//                 disableUnderline: true,
//               }}
//               inputProps={{
//                 inputMode: "numeric",
//                 pattern: "[0-9]*",
//               }}
//             />

//             <button
//               type="submit"
//               disabled={otpLoading}
//               style={{
//                 color: "#0A3D40ff",
//                 width: "100%",
//                 background: "#f7ce46",
//                 padding: "12px",
//                 border: "none",
//                 borderRadius: "8px",
//                 cursor: "pointer",
//                 fontWeight: "bold",
//                 marginTop: "10px",
//               }}
//             >
//               {otpLoading ? "Loading..." : "Get Started"}
//             </button>
//           </form>
//         )}

//         {/* STEP 2 UI */}
//         {step === 2 && (
//           <div>
//             <h3 style={{ marginBottom: "10px", color: "#333" }}>
//               Verify Phone
//             </h3>
//             <p style={{ marginBottom: "20px", color: "#555" }}>
//               Enter the 6-digit OTP sent to your mobile.
//             </p>

//             <form onSubmit={handleOtpSubmit}>
//               <div
//                 style={{
//                   display: "flex",
//                   justifyContent: "center",
//                   gap: "10px",
//                   marginBottom: "20px",
//                 }}
//               >
//                 {otp.map((digit, index) => (
//                   <input
//                     key={index}
//                     type="tel"
//                     value={digit}
//                     maxLength="1"
//                     onChange={(e) => handleOtpChange(index, e.target.value)}
//                     onKeyDown={(e) => handleKeyDown(e, index)}
//                     ref={(el) => (inputRefs.current[index] = el)}
//                     style={{
//                       width: "40px",
//                       height: "40px",
//                       textAlign: "center",
//                       fontSize: "20px",
//                       borderRadius: "6px",
//                       border: "1px solid #ccc",
//                       background: "white",
//                     }}
//                   />
//                 ))}
//               </div>

//               <button
//                 type="submit"
//                 disabled={otpLoading}
//                 style={{
//                   width: "100%",
//                   background: "#0A3D40ff",
//                   padding: "12px",
//                   border: "none",
//                   borderRadius: "8px",
//                   cursor: "pointer",
//                   color: "white",
//                   fontWeight: "bold",
//                 }}
//               >
//                 {otpLoading ? "Loading..." : "Verify & Proceed"}
//               </button>
//             </form>
//           </div>
//         )}
//       </div>

//       {/* Modal */}
//       {openModal && (
//         <div
//           style={{
//             position: "fixed",
//             top: "50%",
//             left: "50%",
//             transform: "translate(-50%, -50%)",
//             width: "400px",
//             backgroundColor: "white",
//             padding: "20px",
//             borderRadius: "8px",
//             boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
//             color: "black",
//           }}
//         >
//           <h3 style={{ marginBottom: "10px" }}>Select Manufacturer</h3>
//           {mfrDetails.map((mfr) => (
//             <div
//               key={mfr.id}
//               onClick={() => handleMfrSelection(mfr)}
//               style={{
//                 padding: "10px",
//                 border: "1px solid #eee",
//                 marginBottom: "5px",
//                 cursor: "pointer",
//               }}
//             >
//               <p style={{ fontWeight: "bold" }}>{mfr.storeDetails.name}</p>
//               <p>{mfr.mobile}</p>
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// export default LoginPage;
// LoginPage.jsx — Updated to support multi-MFR login flow
// All original logic preserved; MFR selection now happens AFTER mobile submit (before OTP)

import React, { useState, useContext, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { TextField, Typography, InputAdornment } from "@mui/material";
import axios from "axios";
import { OrderContext } from "../contexts/OrderContext";
import phone from "../assets/img/ic_phone_16.png";
import { useParams } from "react-router-dom";

const LoginPage = () => {
  const { code } = useParams();

  // step 1 = enter mobile, step 2 = select MFR (if multiple), step 3 = enter OTP
  const [step, setStep] = useState(1);
  const [mobile, setMobile] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [mfrList, setMfrList] = useState([]); // list returned from login API
  const [selectedMfrId, setSelectedMfrId] = useState(null); // mfr_id chosen by user
  const [selectedUserId, setSelectedUserId] = useState(null); // users.id for the chosen mfr
  const [loading, setLoading] = useState(false);
  const [otpLoading, setOtpLoading] = useState(false);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [storeinfo, setStorinfo] = useState([]);
  const { fetchOrders, fetchStoreData } = useContext(OrderContext);
  const inputRefs = useRef([]);
  const navigate = useNavigate();

  // ─── Fetch store by URL code ──────────────────────────────────────────────
  const fetchStore = async (code) => {
    if (!code) return;
    try {
      const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/api/fetchorder/getStore/${code}`;
      const response = await axios.get(apiUrl);
      setStorinfo(response.data);
    } catch (error) {
      console.error("Error fetching store:", error);
    }
  };

  useEffect(() => {
    if (code) {
      localStorage.setItem("urlPrefix", code);
      fetchStore(code);
    }
  }, [code]);

  // ─── STEP 1: Submit mobile number ─────────────────────────────────────────
  // Backend now returns { mfrList: [...], message: "OTP sent" }
  // mfrList has 1 item  → skip MFR selector, go straight to OTP (step 3)
  // mfrList has >1 item → show MFR selector (step 2), then OTP (step 3)
  const handleMobileSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!mobile) {
      setError("Mobile number is required.");
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/auth/login`,
        { mobile },
      );

      const { mfrList: returnedMfrList, message } = response.data.data;
      setMfrList(returnedMfrList || []);
      setSuccess(message || "OTP sent successfully.");

      if (returnedMfrList && returnedMfrList.length > 1) {
        // Multiple MFRs — let user pick before OTP entry
        // If store code is present and matches one mfr, auto-select it
        if (storeinfo?.storeDetails) {
          const autoMatch = returnedMfrList.find(
            (m) => m.storeId === storeinfo.storeDetails.id,
          );
          if (autoMatch) {
            setSelectedMfrId(autoMatch.mfrId);
            setSelectedUserId(autoMatch.userId);
            setStep(3); // skip picker
            return;
          }
        }
        setStep(2);
      } else if (returnedMfrList && returnedMfrList.length === 1) {
        // Only one account — auto-select
        setSelectedMfrId(returnedMfrList[0].mfrId);
        setSelectedUserId(returnedMfrList[0].userId);
        setStep(3);
      } else {
        // Fallback
        setStep(3);
      }
    } catch (error) {
      setError(
        error.response?.data?.data?.message ||
          "Failed to send OTP. Please try again.",
      );
    } finally {
      setLoading(false);
    }
  };

  // ─── STEP 2: User selects MFR ─────────────────────────────────────────────
  const handleMfrSelect = (mfrId, userId) => {
    setSelectedMfrId(mfrId);
    setSelectedUserId(userId);
    setStep(3);
  };

  // ─── STEP 3: Submit OTP ───────────────────────────────────────────────────
  // Now sends mfr_id along with mobile + otp so backend validates against the
  // correct users row (same mobile, correct mfr)
  const handleOtpSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    const enteredOtp = otp.join("");
    if (enteredOtp.length !== 6) {
      setError("Please enter a 6-digit OTP.");
      return;
    }

    setOtpLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/auth/validate-otp`,
        {
          mobile,
          otp: enteredOtp,
          user_id: selectedUserId,
          mfr_id: selectedMfrId,
        },
      );

      const { token, role, mfrDetails, id, user } = response.data.data;

      localStorage.setItem("authToken", token.token);
      localStorage.setItem("userRole", role);
      localStorage.setItem("id", id);
      localStorage.setItem("user", JSON.stringify(user));
      localStorage.setItem("selectedMfr", JSON.stringify(mfrDetails));

      // ─── Role-based navigation (unchanged from original) ──────────────────
      if (role === "Karigar") {
        await fetchOrders();
        await fetchStoreData(); // load the selected store's master data (designs/stone/brand/…)
        navigate("/home");
      } else if (role === "MFR") {
        await fetchOrders();
        await fetchStoreData();
        navigate("/home");
      } else if (
        role === "Customer" ||
        role === "SEMIMFR" ||
        role === "SUPERADMIN" ||
        role === "COMFR"
      ) {
        await fetchOrders();
        await fetchStoreData();
        navigate("/home");
      } else if (role === "DIGITAL MARKETER") {
        await fetchOrders();
        await fetchStoreData();
        navigate("/admin-dash");
      } else if (role === "WAREHOUSE") {
        await fetchOrders();
        await fetchStoreData();
        navigate("/warehouse-dashboard");
      } else if (role === "salesPerson" || role === "ORDER") {
        await fetchOrders();
        await fetchStoreData();
        navigate("/sales-dashboard");
      } else if (role === "QC") {
        await fetchOrders();
        await fetchStoreData();
        navigate("/qrscan");
      } else if (role === "DIGITAL ORDER") {
        await fetchOrders();
        await fetchStoreData();
        navigate("/home");
      } else {
        navigate("/home");
      }
    } catch (error) {
      setError(
        error.response?.data?.data?.message ||
          "Failed to validate OTP. Please try again.",
      );
    } finally {
      setOtpLoading(false);
    }
  };

  // ─── OTP input helpers ────────────────────────────────────────────────────
  const handleOtpChange = (index, value) => {
    if (/^\d?$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      if (value !== "" && index < 5) {
        inputRefs.current[index + 1].focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const handleMobileChange = (e) => {
    const value = e.target.value;
    if (/^\d{0,10}$/.test(value)) {
      setMobile(value);
    }
  };

  // ─── Shared styles ────────────────────────────────────────────────────────
  const cardStyle = {
    width: "100%",
    maxWidth: "420px",
    background: "white",
    borderRadius: "16px",
    padding: "32px 28px",
    boxShadow: "0 24px 48px -12px rgba(6, 40, 42, 0.35)",
    textAlign: "center",
  };

  const primaryBtnStyle = {
    width: "100%",
    background: "#0D7377",
    padding: "13px",
    border: "none",
    borderRadius: "10px",
    cursor: "pointer",
    color: "white",
    fontWeight: 600,
    fontSize: "15px",
  };

  const yellowBtnStyle = {
    ...primaryBtnStyle,
    background: "#0D7377",
    color: "#ffffff",
  };

  // ─── Render ───────────────────────────────────────────────────────────────
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        background: "linear-gradient(160deg, #0A2E31 0%, #0D3B3E 45%, #0D7377 100%)",
        padding: "20px",
      }}
    >
      <div style={cardStyle}>
        {/* Brand */}
        <h2
          style={{
            fontWeight: 700,
            fontSize: "26px",
            letterSpacing: "-0.01em",
            color: "#0A3D40",
            marginBottom: 6,
          }}
        >
          {storeinfo?.storeDetails?.name || "KRAMASYA"}
        </h2>
        <p
          style={{
            color: "#6B7280",
            fontSize: "14px",
            lineHeight: 1.5,
            marginBottom: "24px",
          }}
        >
          Effortless Order Management <br /> for Timeless Creations.
        </p>

        {/* Feature bullets — only on step 1 */}
        {step === 1 && (
          <div
            style={{
              background: "#EEF7F7",
              border: "1px solid #D5ECEC",
              padding: "14px 16px",
              borderRadius: "10px",
              textAlign: "left",
              marginBottom: "24px",
              fontSize: "14px",
              color: "#374151",
              lineHeight: "1.8",
            }}
          >
            ✓ Overview of all order statuses. <br />
            ✓ Order Management <br />
            ✓ Order Tracking &amp; Notifications <br />✓ User Role-Based Access
          </div>
        )}

        {/* Feedback */}
        {error && (
          <p
            style={{
              color: "#B91C1C",
              background: "#FEF2F2",
              border: "1px solid #FECACA",
              borderRadius: "8px",
              padding: "10px 12px",
              fontSize: "14px",
              textAlign: "left",
              marginBottom: 12,
            }}
          >
            {error}
          </p>
        )}
        {success && (
          <p
            style={{
              color: "#15803D",
              background: "#F0FDF4",
              border: "1px solid #BBF7D0",
              borderRadius: "8px",
              padding: "10px 12px",
              fontSize: "14px",
              textAlign: "left",
              marginBottom: 12,
            }}
          >
            {success}
          </p>
        )}

        {/* ── STEP 1: Enter mobile ── */}
        {step === 1 && (
          <form onSubmit={handleMobileSubmit}>
            <Typography
              sx={{
                textAlign: "left",
                marginBottom: "6px",
                color: "#374151",
                fontSize: "14px",
                fontWeight: 500,
              }}
            >
              Enter Mobile Number
            </Typography>
            <TextField
              fullWidth
              type="tel"
              value={mobile}
              onChange={handleMobileChange}
              sx={{ background: "#fff", borderRadius: "10px", marginBottom: 2 }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <img
                      src={phone}
                      alt="Phone"
                      style={{ width: "22px", opacity: 0.7 }}
                    />
                  </InputAdornment>
                ),
                disableUnderline: true,
              }}
              inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
            />
            <button type="submit" disabled={loading} style={yellowBtnStyle}>
              {loading ? "Sending OTP..." : "Get Started"}
            </button>
          </form>
        )}

        {/* ── STEP 2: Select MFR ── */}
        {step === 2 && (
          <div>
            <h3
              style={{
                marginBottom: "8px",
                color: "#1F2937",
                fontSize: "20px",
                fontWeight: 700,
              }}
            >
              Select Store
            </h3>
            <p
              style={{ marginBottom: "16px", color: "#6B7280", fontSize: "14px" }}
            >
              Your number is linked to multiple stores. Choose one to continue.
            </p>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "10px" }}
            >
              {mfrList.map((mfr) => (
                <button
                  key={mfr.mfrId}
                  onClick={() => handleMfrSelect(mfr.mfrId, mfr.userId)}
                  style={{
                    padding: "12px 16px",
                    border: "1px solid #E4E7EC",
                    borderRadius: "10px",
                    background: "#ffffff",
                    cursor: "pointer",
                    textAlign: "left",
                    transition: "background 0.2s",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.background = "#EEF7F7")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.background = "#ffffff")
                  }
                >
                  <p
                    style={{ fontWeight: 600, margin: 0, color: "#0A3D40" }}
                  >
                    {mfr.storeName || mfr.mfrName}
                  </p>
                  {mfr.storePlace && (
                    <p style={{ margin: 0, fontSize: "13px", color: "#6B7280" }}>
                      {mfr.storePlace}
                    </p>
                  )}
                </button>
              ))}
            </div>
            <button
              onClick={() => {
                setStep(1);
                setError("");
                setSuccess("");
              }}
              style={{
                ...primaryBtnStyle,
                marginTop: "16px",
                background: "#F3F4F6",
                color: "#374151",
              }}
            >
              ← Back
            </button>
          </div>
        )}

        {/* ── STEP 3: Enter OTP ── */}
        {step === 3 && (
          <div>
            <h3
              style={{
                marginBottom: "8px",
                color: "#1F2937",
                fontSize: "20px",
                fontWeight: 700,
              }}
            >
              Verify Phone
            </h3>
            <p
              style={{ marginBottom: "20px", color: "#6B7280", fontSize: "14px" }}
            >
              Enter the 6-digit OTP sent to <strong>{mobile}</strong>.
            </p>
            <form onSubmit={handleOtpSubmit}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "10px",
                  marginBottom: "20px",
                }}
              >
                {otp.map((digit, index) => (
                  <input
                    key={index}
                    type="tel"
                    value={digit}
                    maxLength="1"
                    onChange={(e) => handleOtpChange(index, e.target.value)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    ref={(el) => (inputRefs.current[index] = el)}
                    style={{
                      width: "44px",
                      height: "50px",
                      textAlign: "center",
                      fontSize: "20px",
                      fontWeight: 600,
                      color: "#1F2937",
                      borderRadius: "10px",
                      border: "1px solid #D0D5DD",
                      background: "white",
                      outline: "none",
                    }}
                  />
                ))}
              </div>
              <button
                type="submit"
                disabled={otpLoading}
                style={primaryBtnStyle}
              >
                {otpLoading ? "Verifying..." : "Verify & Proceed"}
              </button>
            </form>
            <button
              onClick={() => {
                setStep(mfrList.length > 1 ? 2 : 1);
                setOtp(["", "", "", "", "", ""]);
                setError("");
                setSuccess("");
              }}
              style={{
                ...primaryBtnStyle,
                marginTop: "10px",
                background: "#F3F4F6",
                color: "#374151",
              }}
            >
              ← Back
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default LoginPage;
